






















































/* tslint:disable:no-console */

import { Component, Vue, PropSync, Prop } from 'vue-property-decorator';

@Component({
    props: {
        title: String,
        description: String,
        // items: Array,
    },
})
export default class SettingsList extends Vue {

    // this is so bad, i know, needs refactoring !
    private dialog: {status: boolean, value: string, editIndex?: number} = {
        status: false,
        value: '',
        editIndex: undefined,
    };

    @PropSync('items', { type: Array }) private itemsList!: string[];

    private deleteItem(index: number) {
        this.itemsList.splice(index, 1);
        this.$emit('update:items', this.itemsList);
    }

    private addItem(value: string) {
        this.itemsList.push(value);
        this.$emit('update:items', this.itemsList);
        this.dialog.status = false;
    }

    private updateItem(index: number, value: string) {
        this.itemsList[index] = value;
        this.$emit('update:items', this.itemsList);
        this.dialog.status = false;
    }

    private showAddDialog() {
        this.dialog.value = '';
        this.dialog.status = true;
        this.dialog.editIndex = undefined;
    }

    private showEditDialog(index: number, value: string) {
        this.dialog.value = value;
        this.dialog.status = true;
        this.dialog.editIndex = index;
    }
}
